import React from "react";
import { useNavigate } from "react-router-dom";
import { XCircle } from "lucide-react";
import MobileShell from "@/components/MobileShell";
import { useLang } from "@/context/LangContext";

export default function PaymentCancel() {
  const nav = useNavigate();
  const { t } = useLang();
  return (
    <MobileShell>
      <div className="min-h-screen flex flex-col items-center justify-center text-center px-8" data-testid="payment-cancel">
        <XCircle className="text-slate-400 mx-auto" size={48} />
        <h1 className="font-heading text-xl font-extrabold text-white mt-5">{t("pay_cancel_title")}</h1>
        <p className="text-slate-400 text-sm mt-1">{t("pay_cancel_sub")}</p>
        <button onClick={() => nav("/upgrade")} data-testid="retry-upgrade-btn" className="mt-6 w-full mel-gradient text-white font-bold py-3.5 rounded-2xl press">{t("back_premium")}</button>
        <button onClick={() => nav("/home")} className="mt-2 w-full text-slate-400 font-medium py-2 press">{t("back_home")}</button>
      </div>
    </MobileShell>
  );
}
